import $ from 'jquery';

export default function utils() {
  $('input.group_checker').on('change', function () {
    var $this = $(this);
    var target = $this.data('target');
    if ($this.prop('checked')) {
      $(target).prop('checked', true);
    } else {
      $(target).prop('checked', false);
    }
  });
}
